"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshCookie = void 0;

var _noAuthApiClient = _interopRequireDefault(require("./clients/noAuthApiClient"));

var _core = require("./middlewares/core");

var hubspot = (0, _core.standardApi)('api', 'hubspot');

var refreshCookieForApi = function refreshCookieForApi(portalId, api, withNoCacheHeader) {
  var headers = {
    'X-Force-Cookie-Refresh': true
  };

  if (withNoCacheHeader) {
    headers['X-Force-Cookie-Refresh-No-Cache'] = true;
  }

  var query = portalId ? {
    portalId: portalId
  } : {};
  var path = "/login-api/v1/cookie-refresh" + (portalId ? '' : '/hubless');
  return _noAuthApiClient.default.get(path, {
    api: api,
    headers: headers,
    withCredentials: true,
    query: query
  });
};

var refreshCookie = function refreshCookie(portalId) {
  var withNoCacheHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return refreshCookieForApi(portalId, hubspot, withNoCacheHeader);
};

exports.refreshCookie = refreshCookie;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.227/js/auth.js
// module id = 348
// module chunks = 5 6